import Offcanvas from 'react-bootstrap/Offcanvas';
import './../css/GRecentJobs.css';
import './../css/GSideBar.css';
import './../css/Gtop.css';
import './../css/GFooter.css';
import './../css/GPage2.css';
import './../css/GPage3.css';
import './../css/GEmployers-single.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import GHeader from './GHeader';
import GFooter from './GFooter';
import GJobsHubMenu from './GJobsHubMenu';
import GJobSubHeader from './GJobSubHeader';
import GCandidateInfo from "./GCandidateInfo";
import GJobSingleRecentjobs from "./GJobSingleRecentjobs";
import GSingleSider from './GSingleSider';
import GSignImg from './GSignImg';
import {Endpoint,getDecryptedValueByProperty,fetchOperation, handleEncode,getHeaders,systemConfiguration,includeScripts, includeBootstrapCss, includeBundleBootstrapCss,Properties} from '../../CommonImports';
import {useEffect,useState } from '../../InBuildImports';



function GCandidateSingle() {
    const sasToken = systemConfiguration.AZURE_FTP_GRASTECH3JOBS_SAAS_TOKEN;
    const mediaUrl = 'https://grastechftp.blob.core.windows.net/grastech3jobs/media/icons/';
    const token = getDecryptedValueByProperty(Properties.SESSION_TOKEN_PROP);
    const [loading, setLoading] = useState(false);
    const [candidatesData, setCandidatesData] = useState([]);
    const emailId = "test@gmail.com";//systemConfiguration.SCHOOL_ID;
    const userId = "9284735629";//systemConfiguration.SCHOOL_ID;
  
          const Header_Json=getHeaders(token,handleEncode(userId))

   const fetchCandidatesDetails = async () => {
           setLoading(true);
      
           const url=`${systemConfiguration.HOST}${Endpoint.GJOBS_CONTROLLER_REQ_MAPPING+Endpoint.GET_CANDIDATE_DETAILS_BY_EMAIL}${emailId}`
           const response = await fetchOperation(url,Header_Json);
           console.log('Fetched candidates details:', response);
           setCandidatesData(response);
           setLoading(false);
       
   };

    useEffect(() => {
        fetchCandidatesDetails();
        includeBootstrapCss();
        includeBundleBootstrapCss();
        includeScripts();
        document.addEventListener("DOMContentLoaded", function () {
            if (window.innerWidth >= 992) {
                const sidebar = Offcanvas(document.getElementById(Properties.SIDEBAR_MENU_PROP));
                sidebar.show();
            }
        });
    }, []);


    return (
        <div>
            <GHeader />
            <GJobsHubMenu />
            <GJobSubHeader />
            <section className ="section-box mt-50">
                <div className ="container">
                    <div className ="row">

                        <div className ="col-lg-8 col-md-12 col-sm-12 col-12">
                            
                           <GCandidateInfo candidatesData={candidatesData}/>
                        {/* Insted of Recent jobs add OpeningJob as a header */}

                          <GJobSingleRecentjobs />   
                        </div>
                      <GSingleSider />
                    </div>
                </div>
            </section>

            <section className ="section-box my-5">
                <GSignImg/>
            </section>
            <GFooter />
        </div>
    );
}
export default GCandidateSingle;